import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DesifarmLoginService } from 'src/app/services/desifarm-auth/desifarm-login/desifarm-login.service';
import { DesifarmCommonService } from 'src/app/services/desifarm-common/desifarm-common.service';
import { FranchiseOpportunityService } from 'src/app/services/desifarms-ourstore/desifarms-franchiseoutlet/franchise-opportunity.service';

@Component({
  selector: 'app-desifarms-franchiseoutlet',
  templateUrl: './desifarms-franchiseoutlet.component.html',
  styleUrls: ['./desifarms-franchiseoutlet.component.scss']
})
export class DesifarmsFranchiseoutletComponent implements OnInit {

  form: FormGroup
  msgFlag: boolean = false
  message: string = "Your Enquery is Submitted Successfully.."

  constructor(
    private _fb: FormBuilder,
    private _commonService: DesifarmCommonService,
    private _authService: DesifarmLoginService,
    private _franchiseOpportunityService: FranchiseOpportunityService,
    private _dialog: MatDialog,
  ) { }

  initForm() {
    this.form = this._fb.group({
      Contact_Person_Name: ['', Validators.required],
      Email_Id: ['', [Validators.email]],
      Contact_No_1: ['', [Validators.required, Validators.pattern('[0-9]*')]],
      Area_Based_In: ['', Validators.required],
      Current_Occupation: ['', Validators.required],
      Other_Information: [''],
    })
  }

  showMsg(message: string) {
    this.message = message
    this.msgFlag = true
    setTimeout(() => {
      this.msgFlag = false
    }, 2000)
  }

  ngOnInit(): void {
    this.initForm()
  }

  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  get f() {
    return this.form
  }

  onSubmit() {
    if (this.form.valid) {
      this._commonService._spinner.show()
      this._franchiseOpportunityService.insertFranchiseOpportunity(this.form.value).subscribe((res: any) => {
        this._commonService._spinner.hide()
        if (res.ack) {
          this.form.reset()
          this.showMsg(res.msg)
          // this._commonService.onSuccess(res.msg)
        }
      }, (err) => {
        this._commonService._spinner.hide()
        this._commonService.onSuccess("Internet Connection Failed")
      })
    }
  }

}
